import { create } from 'zustand';

type AuthMode = 'signin' | 'signup';

type AuthDraftState = {
  mode: AuthMode;
  email: string;
  password: string;
  confirmPassword: string;
  acceptedTerms: boolean;
  confirmedAge: boolean;
};

type AuthDraftActions = {
  setMode: (mode: AuthMode) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setConfirmPassword: (confirmPassword: string) => void;
  setAcceptedTerms: (accepted: boolean) => void;
  setConfirmedAge: (confirmed: boolean) => void;
  reset: (next?: Partial<AuthDraftState>) => void;
};

const initialState: AuthDraftState = {
  mode: 'signup',
  email: '',
  password: '',
  confirmPassword: '',
  acceptedTerms: false,
  confirmedAge: false,
};

/**
 * In-memory draft state for auth forms.
 * Purpose: keep user-entered values when navigating to Terms/Privacy and back.
 * Note: we intentionally do NOT persist this to disk.
 */
export const useAuthDraftStore = create<AuthDraftState & AuthDraftActions>((set) => ({
  ...initialState,
  setMode: (mode) => set(() => ({ mode })),
  setEmail: (email) => set(() => ({ email })),
  setPassword: (password) => set(() => ({ password })),
  setConfirmPassword: (confirmPassword) => set(() => ({ confirmPassword })),
  setAcceptedTerms: (acceptedTerms) => set(() => ({ acceptedTerms })),
  setConfirmedAge: (confirmedAge) => set(() => ({ confirmedAge })),
  reset: (next) =>
    set(() => ({
      ...initialState,
      ...(next || {}),
    })),
}));

